// EntityChip resolves a URN to its canonical label and entity-type,
// then renders a compact pill. Falls back to a <code> span on miss.

import { useEntity } from '../lib/useEntity.js';

const TYPE_GLYPHS = {
  project:      '◈',
  person:       '◉',
  agent:        '◎',
  'agent-role': '◎',
  department:   '⬡',
  task:         '☐',
  document:     '□',
  memory:       '◇',
  episode:      '◈',
  collection:   '⊞',
  channel:      '⌁',
  thread:       '⌁',
};

function glyphFor(type) {
  return TYPE_GLYPHS[type] || '·';
}

export function EntityChip({ urn, compact = false, onClick }) {
  const { data, status } = useEntity(urn);

  if (!urn) return null;

  if (status === 'miss' || (!data && status !== 'loading')) {
    return <code className="cx-ent-fallback" style={{ fontSize: 11, opacity: 0.6 }}>{urn?.split(':').pop() ?? ''}</code>;
  }

  const label = data?.payload?.name
    || data?.payload?.label
    || data?.payload?.title
    || data?.envelope?.display_name
    || (urn?.split(':').pop() ?? '');
  const type = data?.entity_type || '';
  const hint = data?.payload?.hint || type;

  return (
    <span
      className={`cx-ent cx-ent-${type}${compact ? ' cx-ent-compact' : ''}`}
      onClick={onClick}
      title={hint}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 3,
        fontFamily: 'var(--ff-serif)',
        fontStyle: 'italic',
        fontSize: compact ? 12 : 13,
        padding: compact ? '1px 6px' : '2px 8px',
        border: '1px solid var(--rule-2)',
        borderRadius: 99,
        color: 'var(--ink-soft)',
        cursor: onClick ? 'pointer' : 'default',
        whiteSpace: 'nowrap',
        opacity: status === 'loading' ? 0.5 : 1,
      }}
    >
      <span style={{ fontSize: compact ? 9 : 10, opacity: 0.7 }}>{glyphFor(type)}</span>
      <span>{label}</span>
      {!compact && type && (
        <span style={{ fontFamily: 'var(--ff-mono)', fontSize: 9, textTransform: 'uppercase', letterSpacing: '0.06em', opacity: 0.6 }}>{type}</span>
      )}
    </span>
  );
}
